export const ANSWERS_TYPES = {
  SINGLE: 'one_answer',
  MULTIPLE: 'multiple_answers',
  TEXT: 'free_text',
};
